import type { ExerciseListResponse, UiLanguage } from '@pebblecode/shared';
import { useEffect, useState } from 'react';

import { api } from '../api/client.js';

const cache = new Map<UiLanguage, Promise<ExerciseListResponse>>();

/** The exercise catalog in a language, fetched once per page load. */
export function loadCatalog(lang: UiLanguage): Promise<ExerciseListResponse> {
  let p = cache.get(lang);
  if (!p) {
    p = api.exercises(lang);
    p.catch(() => cache.delete(lang));
    cache.set(lang, p);
  }
  return p;
}

/** slug → localized title, for reward labels ("Solved Sum of digits"). */
export function useExerciseTitles(lang: UiLanguage): Map<string, string> {
  const [titles, setTitles] = useState<Map<string, string>>(new Map());
  useEffect(() => {
    let live = true;
    loadCatalog(lang)
      .then((c) => live && setTitles(new Map(c.exercises.map((e) => [e.slug, e.title]))))
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [lang]);
  return titles;
}
